import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/ico/phone.svg'
import _imports_1 from '@/assets/ico/viber.svg'
import _imports_2 from '@/assets/ico/telegram.svg'
import _imports_3 from '@/assets/ico/twitter.svg'
import _imports_4 from '@/assets/ico/github.svg'
import _imports_5 from '@/assets/ico/pinterest.svg'
import _imports_6 from '@/assets/ico/linkedin.svg'
import _imports_7 from '@/assets/ico/facebook.svg'
import _imports_8 from '@/assets/ico/youtube.svg'
import _imports_9 from '@/assets/ico/mail.svg'
import _imports_10 from '@/assets/ico/download.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "photo" }
const _hoisted_4 = { class: "icons" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { style: {"font-weight":"bold","font-style":"italic"} }
const _hoisted_17 = { style: {"font-weight":"bold","font-style":"italic"} }
const _hoisted_18 = { class: "slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainPhoto = _resolveComponent("MainPhoto")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('main.name')), 1),
    _createVNode(_Transition, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("h2", {
          key: _ctx.currentText,
          class: _normalizeClass(["slide-fade", { 'fade-in': _ctx.fadeIn }])
        }, _toDisplayString(_ctx.$t(_ctx.currentText)), 3))
      ]),
      _: 1
    }),
    _cache[11] || (_cache[11] = _createElementVNode("line", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MainPhoto)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: "https://wa.me/380504411801",
          title: _ctx.$t('main.whatsApp'),
          target: "_blank"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_0,
            alt: "WhatsApp"
          }, null, -1)
        ]))], 8, _hoisted_5),
        _createElementVNode("a", {
          href: "viber://chat?number=380504411801",
          title: _ctx.$t('main.viber'),
          target: "_blank"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_1,
            alt: "Viber"
          }, null, -1)
        ]))], 8, _hoisted_6),
        _createElementVNode("a", {
          href: "https://t.me/Zorger27",
          title: _ctx.$t('main.telegram'),
          target: "_blank"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_2,
            alt: "Telegram"
          }, null, -1)
        ]))], 8, _hoisted_7),
        _createElementVNode("a", {
          href: "https://x.com/Regroz",
          title: _ctx.$t('main.twitter'),
          target: "_blank"
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_3,
            alt: "Twitter"
          }, null, -1)
        ]))], 8, _hoisted_8),
        _createElementVNode("a", {
          href: "https://github.com/Zorger27",
          title: _ctx.$t('main.github'),
          target: "_blank"
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_4,
            alt: "Github"
          }, null, -1)
        ]))], 8, _hoisted_9),
        _createElementVNode("a", {
          href: "https://www.pinterest.com/zorger27",
          title: _ctx.$t('main.pinterest'),
          target: "_blank"
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_5,
            alt: "Pinterest"
          }, null, -1)
        ]))], 8, _hoisted_10),
        _createElementVNode("a", {
          href: "https://www.linkedin.com/in/anatolii-zorin/",
          title: _ctx.$t('main.linkedIn'),
          target: "_blank"
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_6,
            alt: "LinkedIn"
          }, null, -1)
        ]))], 8, _hoisted_11),
        _createElementVNode("a", {
          href: "https://www.facebook.com/anatoliy.zorin",
          title: _ctx.$t('main.facebook'),
          target: "_blank"
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_7,
            alt: "Facebook"
          }, null, -1)
        ]))], 8, _hoisted_12),
        _createElementVNode("a", {
          href: "https://www.youtube.com/c/AnatoliiZorin",
          title: _ctx.$t('main.youTube'),
          target: "_blank"
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_8,
            alt: "YouTube"
          }, null, -1)
        ]))], 8, _hoisted_13),
        _cache[10] || (_cache[10] = _createElementVNode("a", {
          href: "mailto:zorger27@gmail.com",
          title: "You can write to me at Zorger27@GMail.com",
          target: "_blank"
        }, [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_9,
            alt: "E-mail"
          })
        ], -1)),
        _createElementVNode("a", {
          href: "/assets/file/Curriculum_VITAE.pdf",
          title: _ctx.$t('main.pdfFormat'),
          target: "_blank"
        }, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("img", {
            class: "logo-image",
            src: _imports_10,
            alt: "Download file"
          }, null, -1)
        ]))], 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('main.info.text01')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('main.info.text02')), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('main.info.text03')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('main.info.text04')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('main.info.text05')), 1),
        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('main.info.text06')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Slider, { images: _ctx.sliderImages }, null, 8, ["images"])
    ])
  ]))
}